import { observer } from 'mobx-react-lite'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import RootStore from '../../store/RootStore'

type Props = {
  title: string
  path: string
  isAdmin?: boolean
}

const AppHeaderButton = observer((props: Props) => {
  const { title, path, isAdmin } = props
  const navigate = useNavigate()
  const location = useLocation()

  const isCurrent = location.pathname.includes(path)

  const hundleNavigate = (e:any) => {
    navigate(path)
    e.preventDefault()
  }

  if (isAdmin && !RootStore.authStore.isAdmin) {
    return <></>
  }

  return (
    <a
      onClick={hundleNavigate}
      className={`App-header-button ${isCurrent ? 'active' : ''}`}
      href={path}
    >
      {title}
    </a>
  )
})

export default AppHeaderButton
